import "./App.css";
import "./styles/loader.css";
import "react-toastify/dist/ReactToastify.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import * as AgGrid from "ag-grid-enterprise";
import { useLocation } from "react-router-dom";
import Router from "./routes";
import ScrollToTop from "./components/shared/ScrollToTop";
import { muiTheme } from "./theme/mui";
import { queryClient } from "./queries";
import { getAuthStore } from "./store";
import {
  capTableAmplitudeInit,
  handleClickForTracking,
  handlePageLoadForTracking,
} from "./amplitudeAnalytics";
import { WarningModal } from "./shared/utils";
import { getShareAuthStore } from "./store/useShareAuthStore";
import BackgroundJobsManager from "./components/backgroundJobs/BackgroundJobsManager";
import Stage4JobsManager from "./components/backgroundJobs/Stage4JobsManager";

const agGridLicenseKey = process.env.REACT_APP_AG_LICENSE_KEY || "";
AgGrid.LicenseManager.setLicenseKey(agGridLicenseKey);

function App() {
  const location = useLocation();

  useEffect(() => {
    capTableAmplitudeInit();
  }, []);

  useEffect(() => {
    handlePageLoadForTracking(location);
  }, [location]);

  const isIframe = window.self !== window.top;

  const [isAllowed, setIsAllowed] = useState<boolean>(isIframe || true);

  useEffect(() => {
    if (isIframe) {
      getAuthStore().clear();
      sessionStorage.clear();
      return undefined;
    } // Skip instance check if running inside an iframe

    const instanceKey = "reactAppInstance";
    const channel = new BroadcastChannel(instanceKey);
    // remove if these exist
    getShareAuthStore().clear();
    sessionStorage.removeItem("sharedAccessToken");

    channel.onmessage = (event) => {
      if (event.data === "CHECK_INSTANCE") {
        channel.postMessage("INSTANCE_ACTIVE");
      } else if (event.data === "INSTANCE_ACTIVE") {
        setIsAllowed(false);
      }
    };

    channel.postMessage("CHECK_INSTANCE");

    return () => {
      channel.close();
    };
  }, []);

  return (
    <>
      {!isAllowed && <WarningModal open={!isAllowed} />}
      {isAllowed && (
        <QueryClientProvider client={queryClient}>
          <ScrollToTop />
          <ThemeProvider theme={muiTheme}>
            <BackgroundJobsManager />
            <Stage4JobsManager />
            <div
              onClick={(e) => {
                handleClickForTracking(e);
              }}
            >
              <Router />
            </div>
            <ToastContainer position="bottom-right" autoClose={2000} />
          </ThemeProvider>
        </QueryClientProvider>
      )}
    </>
  );
}

export default App;
